import { isEmpty } from 'lodash';
import { logoutSuccess, sessionExpired } from '../actions/auth-actions';

const requestErrorHandler = () => next => action => {
  const { error } = action;
  if (!isEmpty(error)) {
    const { status } = error;
    if ( status === 401) {
      next(sessionExpired());
      return next(logoutSuccess());
    }
  }
  return next(action);
};

export default requestErrorHandler;
